export default __webpack_public_path__ + "static/media/phones.138bfa0a.png";